import EFPicture from '@elem/compCommon/EFPicture';
import EfSpec from '@elem/ui/ef-spec';
import css from './index.module.scss';
import Icon1 from './icons/Icon1';
import Icon2 from './icons/Icon2';
import Icon3 from './icons/Icon3';
import Icon4 from './icons/Icon4';
import Icon5 from './icons/Icon5';
import { useGlobal } from '@/utils/useGlobal';
import getLocal from '@/app/utils/i18n';

export default function C() {
    const { useLang } = useGlobal();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const { locale } = getLocal();

    return (
        <section className={`dpu-detail-C dpu-detail-section ${css['dpu-detail-C']}`}>
            {locale !== 'au' && <EfSpec />}
            <div className="box-pc">
                <div className="l">
                    <div className="box t">
                        <EFPicture
                            src={
                                locale === 'au'
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1755161328688/1.jpg'
                                    : '/responsive/picture/delta-pro-ultra/launch/3_3.jpg'
                            }
                            alt={t('secC_list3_title')}
                        />
                        <div className="info">
                            <p className="name">{t('secC_list3_name')}</p>
                            <p className="desc">{t('secC_list3_desc')}</p>
                        </div>
                    </div>
                    <div className="box b">
                        <EFPicture
                            src={
                                locale === 'au'
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1755160928813/6.jpg'
                                    : '/responsive/picture/delta-pro-ultra/launch/3_7.jpg'
                            }
                            alt={t('secC_list7_title')}
                        />
                        <div className="info">
                            <p className="name">{t('secC_list7_name')}</p>
                            <p className="desc">{t('secC_list7_desc')}</p>
                        </div>
                    </div>
                </div>
                <div className="c">
                    <div className="box t">
                        <EFPicture
                            src={
                                locale === 'au'
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1755161329267/2.jpg'
                                    : 'https://websiteoss.ecoflow.com/upload/image/1742958890444/3_2.jpg'
                            }
                            alt={t('secC_list1_title')}
                        />
                        <div className="info">
                            <p className="name">{t('secC_list1_name')}</p>
                            <p className="desc">{t('secC_list1_desc')}</p>
                        </div>
                    </div>
                    <div className="box m">
                        <EFPicture
                            src={
                                locale === 'au'
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1755161329765/4.jpg'
                                    : 'https://websiteoss.ecoflow.com/upload/image/1742958890281/3_1.jpg'
                            }
                            alt={t('secC_list2_title')}
                        />
                        <div className="info">
                            <p className="name">{t('secC_list2_name')}</p>
                            <p className="desc">{t('secC_list2_desc')}</p>
                        </div>
                    </div>
                    <div className="box b">
                        <EFPicture
                            src={
                                locale === 'au'
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1755161330374/7.jpg'
                                    : '/responsive/picture/delta-pro-ultra/launch/3_8.jpg'
                            }
                            alt={t('secC_list8_title')}
                        />
                        <div className="info">
                            <p className="name">{t('secC_list8_name')}</p>
                            <p className="desc">{t('secC_list8_desc')}</p>
                            <ul className="icons">
                                <li className="icon">
                                    <Icon1 />
                                </li>
                                <li className="icon">
                                    <Icon2 />
                                </li>
                                <li className="icon">
                                    <Icon3 />
                                </li>
                                <li className="icon">
                                    <Icon4 />
                                </li>
                                <li className="icon">
                                    <Icon5 />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="r">
                    <div className="box t">
                        <EFPicture
                            src={
                                locale === 'au'
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1755161328977/8.jpg'
                                    : '/responsive/picture/delta-pro-ultra/launch/3_5.jpg'
                            }
                            alt={t('secC_list5_title')}
                        />
                        <div className="info">
                            <p className="name">{t('secC_list5_name')}</p>
                            <p className="desc">{t('secC_list5_desc')}</p>
                        </div>
                    </div>
                    <div className="box m">
                        <EFPicture
                            src={
                                locale === 'au'
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1755161330078/5.jpg'
                                    : '/responsive/picture/delta-pro-ultra/launch/3_9.jpg'
                            }
                            alt={t('secC_list9_title')}
                        />
                        <div className="info">
                            <p className="name">{t('secC_list9_name')}</p>
                            <p className="desc">{t('secC_list9_desc')}</p>
                        </div>
                    </div>
                    <div className="box b">
                        <EFPicture
                            src={
                                locale === 'au'
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1755161329502/3.jpg'
                                    : '/responsive/picture/delta-pro-ultra/launch/3_4.jpg'
                            }
                            alt={t('secC_list4_title')}
                        />
                        <div className="info">
                            <p className="name">{t('secC_list4_name')}</p>
                            <p className="desc">{t('secC_list4_desc')}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="box-h5">
                <div className="l1 box">
                    <EFPicture
                        src={
                            locale === 'au'
                                ? 'https://websiteoss.ecoflow.com/upload/image/1755160927256/1.jpg'
                                : '/responsive/picture/delta-pro-ultra/launch/3_1_768.jpg'
                        }
                        alt={t('secC_list3_title')}
                    />
                    <div className="info">
                        <p className="name">{t('secC_list3_name')}</p>
                        <p className="desc">{t('secC_list3_desc')}</p>
                    </div>
                </div>
                <div className="l2">
                    <div className="l">
                        <div className="t box">
                            <EFPicture
                                src={
                                    locale === 'au'
                                        ? 'https://websiteoss.ecoflow.com/upload/image/1755160927511/2.jpg'
                                        : 'https://websiteoss.ecoflow.com/upload/image/1742958890581/3_2_M.jpg'
                                }
                                alt={t('secC_list_title')}
                            />
                            <div className="info">
                                <p className="name">{t('secC_list2_name')}</p>
                                <p className="desc">{t('secC_list2_desc')}</p>
                            </div>
                        </div>
                        <div className="b box">
                            <EFPicture
                                src={
                                    locale === 'au'
                                        ? 'https://websiteoss.ecoflow.com/upload/image/1755160928064/4.jpg'
                                        : '/responsive/picture/delta-pro-ultra/launch/3_3_768.jpg'
                                }
                                alt={t('secC_list8_title')}
                            />
                            <div className="info">
                                <p className="name">{t('secC_list8_name')}</p>
                                <p className="desc">{t('secC_list8_desc')}</p>
                                <ul className="icons">
                                    <li className="icon">
                                        <Icon1 />
                                    </li>
                                    <li className="icon">
                                        <Icon2 />
                                    </li>
                                    <li className="icon">
                                        <Icon3 />
                                    </li>
                                    <li className="icon">
                                        <Icon4 />
                                    </li>
                                    <li className="icon">
                                        <Icon5 />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="r">
                        <div className="t box">
                            <EFPicture
                                src={
                                    locale === 'au'
                                        ? 'https://websiteoss.ecoflow.com/upload/image/1755160927771/3.jpg'
                                        : 'https://websiteoss.ecoflow.com/upload/image/1742958890785/3_4_M.jpg'
                                }
                                alt={t('secC_list1_title')}
                            />
                            <div className="info">
                                <p className="name">{t('secC_list1_name')}</p>
                                <p className="desc">{t('secC_list1_desc')}</p>
                            </div>
                        </div>
                        <div className="b box">
                            <EFPicture src={'/responsive/picture/delta-pro-ultra/launch/3_5_768.jpg'} alt={t('secC_list4_title')} />
                            <div className="info">
                                <p className="name">{t('secC_list4_name')}</p>
                                <p className="desc">{t('secC_list4_desc')}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="l3 box">
                    <EFPicture
                        src={
                            locale === 'au'
                                ? 'https://websiteoss.ecoflow.com/upload/image/1755160928813/6.jpg'
                                : '/responsive/picture/delta-pro-ultra/launch/3_7.jpg'
                        }
                        alt={t('secC_list7_title')}
                    />
                    <div className="info">
                        <p className="name">{t('secC_list7_name')}</p>
                        <p className="desc">{t('secC_list7_desc')}</p>
                    </div>
                </div>
                <div className="l4">
                    <div className="l box">
                        <EFPicture
                            src={
                                locale === 'au'
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1755160928872/7.jpg'
                                    : '/responsive/picture/delta-pro-ultra/launch/3_7_768.jpg'
                            }
                            alt={t('secC_list5_title')}
                        />
                        <div className="info">
                            <p className="name">{t('secC_list5_name')}</p>
                            <p className="desc">{t('secC_list5_desc')}</p>
                        </div>
                    </div>
                    <div className="r box">
                        <EFPicture
                            src={
                                locale === 'au'
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1755160930228/8.jpg'
                                    : '/responsive/picture/delta-pro-ultra/launch/3_9_768.jpg'
                            }
                            alt={t('secC_list9_title')}
                        />
                        <div className="info">
                            <p className="name">{t('secC_list9_name')}</p>
                            <p className="desc">{t('secC_list9_desc')}</p>
                        </div>
                    </div>
                </div>
            </div>
            <EfSpec />
        </section>
    );
}
